module.exports = __webpack_public_path__ + "static/media/roundClose-img.a0fa7f80.svg";